export const ARRAY_TYPE_CONTRACT: Array<{ _id: number, typeContract: string }> =
    [
        { _id: 1, typeContract: 'Indefinido' },
        { _id: 2, typeContract: 'Plazo Fijo renovable' },
        { _id: 3, typeContract: 'Reemplazo' },
        { _id: 4, typeContract: 'Boleta a honorarios' },
        { _id: 5, typeContract: 'Voluntariado' },
    ];


export enum TYPE_CONTRACT {
    "Indefinido",
    "Plazo Fijo renovable",
    "Reemplazo",
    "Boleta a honorarios",
    "Voluntariado",
}
